import { render } from "./QRCodeStyling.vue?vue&type=template&id=20980ef8&scoped=true&ts=true"
import script from "./QRCodeStyling.vue?vue&type=script&lang=ts"
export * from "./QRCodeStyling.vue?vue&type=script&lang=ts"

import "./QRCodeStyling.vue?vue&type=style&index=0&id=20980ef8&scoped=true&lang=css"

import exportComponent from "/home/mat/Descargas/qr-code-styling-examples-master/examples/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20980ef8"]])

export default __exports__